export function MonthlyMarathonIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="8" y="8" width="32" height="32" rx="3" />
      <line x1="8" y1="16" x2="40" y2="16" />
      <line x1="16" y1="8" x2="16" y2="12" />
      <line x1="32" y1="8" x2="32" y2="12" />
      <circle cx="15" cy="22" r="1.5" fill="currentColor" />
      <circle cx="21" cy="22" r="1.5" fill="currentColor" />
      <circle cx="27" cy="22" r="1.5" fill="currentColor" />
      <circle cx="33" cy="22" r="1.5" fill="currentColor" />
      <circle cx="15" cy="28" r="1.5" fill="currentColor" />
      <circle cx="21" cy="28" r="1.5" fill="currentColor" />
      <circle cx="27" cy="28" r="1.5" fill="currentColor" />
      <circle cx="33" cy="28" r="1.5" fill="currentColor" />
      <circle cx="15" cy="34" r="1.5" fill="currentColor" />
      <circle cx="21" cy="34" r="1.5" fill="currentColor" />
      <circle cx="27" cy="34" r="1.5" fill="currentColor" />
      <circle cx="33" cy="34" r="1.5" fill="currentColor" />
    </svg>
  );
}
